import type { SearchRecordsBody } from './types';

const searchIdentity = (body: SearchRecordsBody) =>
  JSON.stringify([body.page, body.limit, body.detailed, body.demoMode, body.filters]);

/**
 * True when `previousKey` (a `queryKeys.tableRecords` key) is the same search on the same table
 * and only the requested columns differ, so its rows can stay on screen while the new columns load.
 */
export const isSameRecordsSearchIgnoringColumns = (
  previousKey: readonly unknown[] | undefined,
  tableId: string | undefined,
  body: SearchRecordsBody
): boolean => {
  if (!previousKey || previousKey[1] !== tableId) return false;
  const previousBody = previousKey[2] as SearchRecordsBody | undefined;
  return (
    Boolean(previousBody) &&
    searchIdentity(previousBody as SearchRecordsBody) === searchIdentity(body)
  );
};
